export default __webpack_public_path__ + "f3da10e6e5f02ee5caa674ec0a0a8603.svg";